import {useEffect} from 'react';
import {showToast, useIsMounted} from '@chekinapp/ui';
import {getErrorMessage, type CoreError} from '@chekin/core';

function toastResponseError(error: unknown) {
  showToast.error(getErrorMessage(error as CoreError));
}

type UseErrorToastOptions = {
  notFoundMessage?: string;
  onlyMounted?: boolean;
};

function useErrorToast(error: unknown, options?: UseErrorToastOptions) {
  const notFoundMessage = options?.notFoundMessage;
  const onlyMounted = options?.onlyMounted;
  const isMounted = useIsMounted();

  useEffect(() => {
    if (!error) return;

    if (
      (error as {body?: {status_code?: number}})?.body?.status_code === 404 &&
      notFoundMessage
    ) {
      (error as {message: string}).message = notFoundMessage;
    }

    if (isMounted.current || !onlyMounted) {
      toastResponseError(error);
    }
  }, [error, notFoundMessage, onlyMounted, isMounted]);
}

export {toastResponseError, useErrorToast};
export type {UseErrorToastOptions};
